module.exports = __webpack_public_path__ + "static/media/go-resale@2x.8de28020.png";